import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { setCurrentField, setCurrentCountry } from '../../actions';
import {
  getCurrentField,
  getCurrentCountry,
  getCountriesForRatings,
  getFieldsForRatings,
} from '../../reducers';
import CurrentRating from './CurrentRating';
import AnnualRanking from './AnnualRanking';
import { translateFieldOptions, translateCountryOptions } from '../../utils/fields';

export default function Ratings() {
  const field = useSelector(getCurrentField);
  const country = useSelector(getCurrentCountry);
  const countries = useSelector(getCountriesForRatings);
  const fields = useSelector(getFieldsForRatings);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const translatedFields = useMemo(
    () => translateFieldOptions(fields, t),
    [fields, t]
  );
  const translatedCountries = useMemo(
    () => translateCountryOptions(countries, t, i18n.language || 'en'),
    [countries, t, i18n.language]
  );

  useEffect(() => {
    if (
      countries.length !== 0 &&
      !countries.map(c => c.value).includes(country)
    ) {
      dispatch(setCurrentCountry('INTL'));
    }
  }, [country, countries, dispatch]);

  useEffect(() => {
    if (fields.length !== 0 && !fields.map(f => f.value).includes(field)) {
      dispatch(setCurrentField(fields[0].value));
    }
  }, [field, fields, dispatch]);

  function handleFieldChange(event) {
    dispatch(setCurrentField(event.target.value));
  }

  function handleCountryChange(event) {
    dispatch(setCurrentCountry(event.target.value));
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-auto">
          <h1 style={{ color: '#0A2342', fontWeight: 600 }}>{t('ratings.pageTitle')}</h1>
        </div>
        <div className="col"></div>
        <div className="col-auto d-flex justify-content-end">
          <form className="form-inline">
            <label className="sr-only" htmlFor="country">
              {t('ratings.countryLabel')}
            </label>
            <select
              className="form-control mr-sm-2 mb-2 mb-sm-0 custom-select"
              id="country"
              name="country"
              onChange={handleCountryChange}
              value={country}
            >
              {translatedCountries.map(country => (
                <option key={country.value} value={country.value}>
                  {country.label}
                </option>
              ))}
            </select>
            <label className="sr-only" htmlFor="field">
              {t('ratings.fieldLabel')}
            </label>
            <select
              className="form-control custom-select"
              id="field"
              name="field"
              onChange={handleFieldChange}
              value={field}
            >
              {translatedFields
                .sort((a, b) => a.label.localeCompare(b.label))
                .map(fieldOption => (
                  <option key={fieldOption.value} value={fieldOption.value}>
                    {fieldOption.label}
                  </option>
                ))}
            </select>
          </form>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6">
          <CurrentRating />
        </div>
        
        <div className="col-lg-6">
          <AnnualRanking />
        </div>
      </div>
      <div className="jumbotron jumbotron-fluid mb-3 mt-4">
        <div className="container">
          <h2 style={{ color: '#0A2342' }}>{t('ratings.currentDescriptionTitle')}</h2>
          <p className="lead">
            {t('ratings.currentDescription')}
          </p>

          <h2 style={{ color: '#0A2342' }}>{t('ratings.annualDescriptionTitle')}</h2>
          <p className="lead">
            {t('ratings.annualDescription')}
          </p>
        </div>
      </div>
    </div>
  );
}
